import React from 'react'
import clsx from 'clsx'

/**
 * @typedef {Object} PageWrapperProps
 * @property {React.ReactNode} children - Page content (header, filters, tables, forms).
 * @property {string} [className] - Extra classes merged with the base layout shell (e.g. `accounting-page`, `po-container`).
 * @property {string} [defaultPadding='p-1 py-2 p-md-3'] - Bootstrap spacing classes applied to the wrapper; override when a page needs tighter or no padding.
 */

/**
 * Root layout shell for list pages, reports and forms.
 *
 * Renders a full-width fluid container with the shared app background and responsive padding.
 * Base classes: `container-fluid`, `contenedor`, `t4i-bg-color`, `t4i-page-wrapper`.
 *
 * @param {PageWrapperProps} props
 * @returns {React.ReactElement}
 *
 * @example
 * <PageWrapper className="stock-transfers-container">
 *   <PageHeader title="Stock Transfers" />
 *   <FilterBar>...</FilterBar>
 * </PageWrapper>
 */
export const PageWrapper = ({ children, className, defaultPadding = 'p-1 py-2 p-md-3' }) => {
  return <div className={clsx('container-fluid contenedor t4i-bg-color t4i-page-wrapper', className, defaultPadding)}>{children}</div>
}

export default PageWrapper
